import { render, staticRenderFns } from "./imageBox.vue?vue&type=template&id=19f1c9bc&scoped=true"
import script from "./imageBox.vue?vue&type=script&lang=js"
export * from "./imageBox.vue?vue&type=script&lang=js"
import style0 from "./imageBox.vue?vue&type=style&index=0&id=19f1c9bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f1c9bc",
  null
  
)

export default component.exports